import React, { useState } from "react"
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap"

import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

const ProfileMenu = (props) => {
    const [menu, setMenu] = useState(false)

    const toggle = () => {
        setMenu(!menu)
    }

    return(
        <React.Fragment>
            <Dropdown
                isOpen={menu}
                toggle={ toggle }
                className="d-inline-block"
                onClick={() => {
                    window.analytics.track('Perfil: Menú')
                }}
            >
                <DropdownToggle
                    className="btn header-item waves-effect"
                    id="page-header-user-dropdown"
                    tag="button"
                >
                    <span className="header-item-profile-name">
                        {props && (
                            <span>{props.fullName}</span>
                        )}
                    </span>

                    {props && props.avatar && (
                        <img className="rounded-circle header-profile-user thumbnail"
                            src={props.avatar}
                            alt={props.fullName}
                        />
                    )}

                    {props && !props.avatar && (
                        <img className="rounded-circle header-profile-user thumbnail"
                            src={`https://storage.googleapis.com/vantaapp/assets/avatar-1.png`}
                            alt={props.fullName}
                        />
                    )}

                    <i className="header-item-chevron mdi mdi-chevron-down"></i>
                </DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem tag="a" href="/settings" onClick={() => {
                                window.analytics.track('Ir a Configuraciones')
                            }}>
                        <i className="bx bx-wrench font-size-17 align-middle mr-1"></i>
                        Configuraciones
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    <Link to="/logout" className="dropdown-item" onClick={() => {
                                window.analytics.track('Cerrar Sesión')
                            }}>
                        <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
                        <span>Cerrar Sesión</span>
                    </Link>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return {
        profile: state.Auth?.profile,
        fullName: state.Auth?.profile?.fullName,
        avatar: state.Auth?.profile?.avatar,
    }
}

export default connect(
    mapStatetoProps, { }
)(withRouter(ProfileMenu))
